import React, { memo } from "react";
import ProductFilterInside from "./ProductFilterInside";

const ProductFilters = memo(() => {
  return (
    <div className="filters-wrapper">
      <ProductFilterInside title={"מותג"} parameterName={"subBrand"} />
      <ProductFilterInside
        title={"כשרות"}
        parameterName={"kosherSupervision[0].supervisionAgency"}
      />
      <ProductFilterInside
        title={"חלבי / בשרי"}
        parameterName={"kosherSupervision[0].classification"}
      />
      <ProductFilterInside
        title={"כשרויות נוספות"}
        parameterName={"kosherSupervision[0].kashrutFeature"}
      />
    </div>
  );
});

export default ProductFilters;
